export default __webpack_public_path__ + "static/illustration-default-member-profile-mobile-dfd68e5b170f7888baaed9b219e3d712.svg";